function registerHandleBarsHelpers () {
  Handlebars.registerHelper('addressHelper', function (hotelInfo) {
    let address = [
      hotelInfo.addr1,
      hotelInfo.city,
      hotelInfo.zip,
      hotelInfo.country
    ]
    address = address.filter(function (value) {
      return value
    }).join(', ')
    return address
  })

  Handlebars.registerHelper('t', function () {
    let args = [...arguments]
    args = args.slice(0, -1) // Remove helper object
    const translationString = args.shift()
    // Expects to receive keyName then value (one or more times)
    const params = {}
    for (let i = 0; i < args.length; i += 2) {
      params[args[i]] = args[i + 1]
    }
    return i18next.t(translationString, params)
  })

  Handlebars.registerHelper('condensedDate', function (dateFrom, dateTo, formatFrom, formatTo) {
    const inputDateFormat = 'DD/MM/YYYY'
    const dateFromObj = moment(dateFrom, inputDateFormat)
    const dateToObj = moment(dateTo, inputDateFormat)
    if (dateFromObj.isValid() && dateToObj.isValid()) {
      if (dateFromObj.format('YYYY-MM-DD') === dateToObj.format('YYYY-MM-DD')) {
        return dateFromObj.format(formatTo)
      } else {
        return dateFromObj.format(formatFrom) + ' - ' + dateToObj.format(formatTo)
      }
    } else {
      return 'N/A'
    }
  })

  Handlebars.registerHelper('momentHelper', function (date, format) {
    const dateFormat = 'DD/MM/YYYY'
    const dateObj = moment(date, dateFormat)
    if (!dateObj.isValid()) {
      return 'N/A'
    }
    return dateObj.format(format)
  })

  Handlebars.registerHelper('eqHelper', function (param1, param2) {
    return param1 === param2
  })

  Handlebars.registerHelper('telephoneHelper', function (language, number) {
    const telephoneNumber = '<span dir="ltr"><a href="tel:' + number + '" target="_blank" style="text-decoration:none; color:#FFFFFF;">' + number + '</a></span>'
    const label = i18next.t('email_tel_label')
    return label + ': ' + telephoneNumber
  })

  Handlebars.registerHelper('spacerHelper', function (lang, name, type) {
    const spacerHeights = {
      en: {
        email_box_default_body: '24px',
        email_box_spa_body: '24px'
      },
      de: {
        email_box_default_body: '24px',
        email_box_dinning_body: '24px',
        email_box_spa_body: '24px'
      },
      ru: {
        email_box_default_title: '32px',
        email_box_default_body: '48px',
        email_box_dinning_body: '48px',
        email_box_spa_title: '32px',
        email_box_spa_body: '24px'
      }
    }
    if (!spacerHeights[lang]) return '0px'
    return spacerHeights[lang][`email_box_${name}_${type}`] || '0px'
  })

  Handlebars.registerHelper('buttonPaddingHelper', function (lang) {
    return lang === 'de' ? '12px 40px' : '12px 44px'
  })

  Handlebars.registerHelper('parasToLineBreaks', function (html) {
    if (!html) return ''
    return new Handlebars.SafeString(
      html
        .replace(/<\/p>/gi, '<br>')
        .replace(/<p[^>]*>/gi, '')
        .replace(/(<br\s*\/?>\s*)+$/i, '')
        .trim()
    )
  })

  Handlebars.registerHelper('longTextForceWrap', function (text, every) {
    if (every === undefined || typeof every === 'object') every = 8
    if (!text) return ''
    const s = String(text)
    const SEP = new Set(['.', '@', '_', '+', '-'])
    const TOKEN = '[[WBR]]'
    let out = ''
    let count = 0
    for (let i = 0; i < s.length; i++) {
      const ch = s[i]
      out += ch
      count++
      if (SEP.has(ch) || count >= every) { out += TOKEN; count = 0 }
    }
    const esc = function (str) {
      return str.replace(/[&<>"']/g, function (m) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]
      })
    }
    return new Handlebars.SafeString(esc(out).replaceAll(TOKEN, '<wbr>'))
  })
}

let lng = config.defaultLanguage
let cookieLng = getCookie('i18next')
if (cookieLng !== null) {
  // Remove t= so we just get the language code
  cookieLng = cookieLng.replace('t=', '')
  if (config.supportedLanguages.includes(cookieLng)) {
    lng = cookieLng
  }
}

// i18next init
i18next.use(i18nextHttpBackend).init({
  lng,
  load: 'currentOnly',
  fallbackLng: 'en',
  interpolation: {
    prefix: '__',
    suffix: '__',
    escapeValue: false
  },
  backend: {
    loadPath: '/locales/__lng__/__ns__.json'
  }
}).then(function () {
  registerHandleBarsHelpers()

  $(document).ready(function () {
    if ($('.page-login').length) {
      loginInit()
    }

    if ($('.page-builder').length) {
      builderInit()
    }

    if ($('.page-emailer').length) {
      emailerInit()
    }
  })
})
